import { Button, Card, CardActions, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { ErrorMessage } from "components";
import LoadingIndicator from "components/LoadingIndicator";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Student } from "services";
import snakeToCamel from "utils/snakeToTitle";
import useErrorCatcher from "utils/useErrorCatcher";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
  },
  actions: {
    flexDirection: "column",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
}));

let mounted = false;
const StudentPreview = props => {
  const { studentId, student, className, ...rest } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  let [model, setModel] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));

  useEffect(() => {
    mounted = true;
    return () => mounted = false;
  }, [])

  useEffect(() => {
    if (!student) {
      runAsyncBlock(async () => {
        const { model } = await Student.detail(studentId);
        if (mounted) setModel(model);
      }).finally(() => mounted && setLoading(false));

      return () => {
        if (mounted) setModel(null);
      };
    }
    // eslint-disable-next-line
  }, [studentId]);

  if (!student && !studentId) return null;
  if (student) model = student;

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title="Student" />
      <Divider />
      <CardContent className={classes.content}>
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        {model && (
          <Fragment>
            <Typography variant="h3">{model.name_en}{model.name_zh ? " " + model.name_zh : ""}</Typography>
            <Typography variant="body2" >{snakeToCamel(model.gender)}</Typography>
          </Fragment>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <Button component={RouterLink} size="small" to={`/students/${studentId || student.id}/summary`}>
          View Student Details
        </Button>
      </CardActions>
    </Card>
  );
};

StudentPreview.propTypes = {
  className: PropTypes.string,
};

export default StudentPreview;
